import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const MeterReads = {
  Content: lazy(
    () =>
      import('components/direct-sales/meter-reads/components/MeterReadsContent')
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default MeterReads;
